import React from 'react';
import cn from 'classnames';

import s from '../Navigator.module.scss';

interface NavigationItemProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  active: boolean;
  subnav?: React.ReactNode;
  appSelector?: boolean;
  onClose?: () => void;
}

export const NavigationItem = ({
  icon,
  children,
  active = false,
  subnav,
  appSelector = false,
  onClose,
}: NavigationItemProps): JSX.Element => (
  <li
    onClick={onClose}
    className={cn(
      s.navigator__navItem,
      { [s.navigator__navItemActive]: active },
      { subnav },
      { appSelector }
    )}
  >
    <div className={s.navigator__navItemContent}>
      <span className={s.navigator__navItemIcon}>{icon}</span>
      <span className={s.navigator__navItemNavText}>{children}</span>
    </div>
    {subnav && subnav}
  </li>
);
